import { Box, Button, Divider, Typography } from '@mui/material';
import * as React from 'react';
import { forwardRef } from 'react';

import { TwoFASidebarContainer } from '../../../containers';
import { IOneLinkChunkFormProps } from '../../../contexts/OneLinkSummaryProvider';

const TwoFactorForm = forwardRef<boolean, IOneLinkChunkFormProps>(
  ({ onSubmit, instance, onClose }: IOneLinkChunkFormProps) => {
    const handleSubmit = React.useCallback(() => {
      onSubmit({
        security_info: {
          enabled_2fa: false,
          allowed_domains: instance?.allowed_domains ?? [],
          max_submit_count: instance?.max_submit_count ?? 0,
          password: instance?.password ?? '',
        },
      });
    }, [instance?.max_submit_count, instance?.allowed_domains, instance?.password, onSubmit]);

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, alignItems: 'baseline' }}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Turning off 2FA will not remove confirmed recipients.
          </Typography>
          <Button onClick={handleSubmit} component="div" variant="outlined">
            Turn Off 2FA
          </Button>
        </Box>
        <Divider sx={{ mb: 1 }} />
        <TwoFASidebarContainer nested oneLinkId={instance?.uid} status={instance?.status} onClose={onClose} />
      </Box>
    );
  },
);

export default TwoFactorForm;
